import React from 'react';
import ProductSummary from './ProductSummary/ProductSummary';

export const Summary = () => <ProductSummary />;

export default Summary;
